import { AppleBackdropExpVariants } from '.';
import { AppleBackdropInteractions, ExperimentParams } from './types';

export const appleBackdropAffiliateLinksParams: Record<
	AppleBackdropExpVariants,
	AppleBackdropInteractions<ExperimentParams>
> = {
	control: {
		offers: {
			ct: 'exp-5-control-reg',
			itsct: 'justwatch_tv',
		},
		freeTrial: {
			ct: 'exp-5-control-trial',
			itsct: 'justwatch_tv_5',
			altItsct: 'justwatch_tv_6',
		},
	},
	variant_1: {
		play: {
			ct: 'exp-5-v1-back',
			itsct: 'justwatch_tv_9',
		},
		offers: {
			ct: 'exp-5-v1-reg',
			itsct: 'justwatch_tv',
		},
		freeTrial: {
			ct: 'exp-5-v1-trial',
			itsct: 'justwatch_tv_5',
			altItsct: 'justwatch_tv_6',
		},
	},
	variant_2: {
		play: {
			ct: 'exp-5-v2-back',
			itsct: 'justwatch_tv_10',
		},
		offers: {
			ct: 'exp-5-v2-reg',
			itsct: 'justwatch_tv',
		},
		freeTrial: {
			ct: 'exp-5-v2-trial',
			itsct: 'justwatch_tv_5',
			altItsct: 'justwatch_tv_6',
		},
	},
};
